import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, lowestHpEnemy, livingEnemies, enemySide, getRuntimes, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'splash',
    apply: ({ state, source, params, rng }) => {
        const mult = params.multiplier ?? 1;
        const splashPct = params.splashPct ?? 0.5;
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const target = lowestHpEnemy(state, source.side);
        const sourceRt = (source.side === 'A' ? state.sideA : state.sideB)[source.slot];
        const enemyKey = enemySide(source.side);
        const enemyArr = getRuntimes(state, enemyKey);
        const baseDmg = computeDamage(effectiveAtk(sourceRt) * mult, effectiveDef(target.runtime));
        applyDamage(state, source, { side: enemyKey, slot: target.slot }, baseDmg, false, rng);
        for (const adj of [target.slot - 1, target.slot + 1]) {
            if (adj < 0 || adj >= enemyArr.length)
                continue;
            const r = enemyArr[adj];
            if (!r || !r.alive)
                continue;
            const splashDmg = computeDamage(effectiveAtk(sourceRt) * mult * splashPct, effectiveDef(r));
            applyDamage(state, source, { side: enemyKey, slot: adj }, splashDmg, false, rng);
        }
    }
});
